import * as React from 'react';

// Renders a visually-hidden <table> of chart rows for agents that execute JS.
// Reads the inline <script type="application/json" data-chart-for="<collection>">
// block that Rails injects adjacent to the NvChart div (see PagesHelper
// #inline_chart_data_scripts). Non-JS agents read the same script block
// directly; this component exists only to surface the data as a table for
// tools that prefer tabular structure.
export default function HiddenDataTable({ collectionName }) {
  const rows = React.useMemo(() => {
    if (!collectionName) return null;
    const el = document.querySelector(
      `script[type="application/json"][data-chart-for="${CSS.escape(collectionName)}"]`
    );
    if (!el) return null;
    try {
      const parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch {
      return null;
    }
  }, [collectionName]);

  if (!rows) return null;

  const headers = Object.keys(rows[0]);

  return (
    <table hidden aria-hidden="true" data-chart-collection={collectionName}>
      <thead>
        <tr>{headers.map(h => <th key={h}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            {headers.map(h => <td key={h}>{formatCell(row[h])}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function formatCell(value) {
  if (value == null) return '';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
